import { Flex } from 'antd';
import styled from 'styled-components';

export const HeaderWrapper = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 0 16px;
  }
`;

export const Title = styled.div`
  font-size: 16px;
`;

export const FiltersWrapper = styled(Flex)`
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;

    label {
      white-space: nowrap;
      font-size: 12px;
      padding-inline: 4px;
    }
  }
`;
